/* src/app/components/language-dropdown/language-dropdown.component.scss */
.background-dropdown {
  background: #22262b;
  margin-top: 20px;
  margin-left: -75px;
}
.background-dropdown-item {
  background: #22262b;
}
.background-dropdown-item:hover {
  background-color: #0C85FF;
}
.custom-dropdown .dropdown-toggle::after {
  display: none !important;
}
ul,
li {
  list-style-type: none;
}
/*# sourceMappingURL=language-dropdown.component.css.map */
